const HEADER_IMAGE_HEIGHT: string = '9em';
const HEADER_FONT_SIZE: string = '4em';
const ACCEPTABILITY_ICON_FONT_SIZE: string = '2em';

export {
    HEADER_IMAGE_HEIGHT,
    HEADER_FONT_SIZE,
    ACCEPTABILITY_ICON_FONT_SIZE
}